import { SupportedLanguage, supportedLanguages } from "../locales/resources";

export class LocalesConfig {
  readonly defaultLanguage: SupportedLanguage = "en";

  public resolveLanguage(): SupportedLanguage {
    if (typeof window === "undefined") {
      /**
       * Server locale detection. This requires e.g LANG environment variable to be set on the server.
       */
      const serverLocale = process.env.NMP_LANGUAGE ?? this.defaultLanguage;
      return this.toSupportedLanguage(serverLocale);
    }

    try {
      /**
       * Client locale detection. Expects the lang attribute to be defined.
       */
      const htmlLocale = window.document.documentElement.lang;

      return this.toSupportedLanguage(htmlLocale);
    } catch (e) {
      console.warn(
        "Could not detect locale, falling back to source locale.",
        e
      );
      return this.defaultLanguage;
    }
  }

  private toSupportedLanguage(usedLocale: string): SupportedLanguage {
    return (
      supportedLanguages.find(
        (lang) => lang.toLowerCase() === usedLocale.toLowerCase()
      ) ?? this.defaultLanguage
    );
  }
}
